import { charities } from "../lib/charities";

export const getCharityData = (charityName) => {
  const charityData = charities.find(
    (charity) => charity.title === charityName
  );

  return charityData || charities[0];
};
